import "./about.css";

import React from "react";

import { ABOUT } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageHero, PhotoStrip, Split, SplitItem } from "../general/PageSections";
import Testimonials from "../general/Testimonials";

const About = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={"About Us"}
        description={ABOUT.DESCRIPTION}
      />
      <PageHero src={"/images/about/flowers-table.webp"} />

      <section className={"text-band"}>
        <div className={"container"}>
          <h1 className={"heading"}>{ABOUT.INTRO_TITLE}</h1>
          <p className={"body-text"}>{ABOUT.INTRO}</p>
        </div>
      </section>

      {ABOUT.SPLITS.map((split) => (
        <Split
          key={split.title}
          image={split.image}
          isImageFirst={split.isImageFirst}
        >
          <SplitItem
            title={split.title}
            text={split.text}
          />
        </Split>
      ))}

      <section className={"text-band"}>
        <div className={"container"}>
          <h2 className={"heading"}>{ABOUT.PEACE_TITLE}</h2>
          {ABOUT.PEACE.map((paragraph) => (
            <p
              key={paragraph}
              className={"body-text"}
            >
              {paragraph}
            </p>
          ))}
        </div>
      </section>

      <section className={"about-values"}>
        <div className={"about-values-grid container"}>
          {ABOUT.VALUES.map((value) => (
            <div key={value.title}>
              <h2 className={"heading"}>{value.title}</h2>
              <p className={"body-text"}>{value.text}</p>
            </div>
          ))}
        </div>
      </section>

      <PhotoStrip src={"/images/about/sandton-skyline.webp"} />

      <Testimonials
        items={ABOUT.TESTIMONIALS}
        label={"Guest reviews"}
      />

      <section className={"about-convenience"}>
        <div className={"container"}>
          <h2 className={"heading"}>{ABOUT.CONVENIENCE_TITLE}</h2>
          <div className={"about-convenience-lists"}>
            {ABOUT.CONVENIENCE.map((column, i) => (
              <ul
                key={i}
                className={"check-list"}
              >
                {column.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </section>

      <PhotoStrip src={"/images/about/indoor-venue.webp"} />
    </React.Fragment>
  );
};

export default About;
